import { createComponent } from '@lit-labs/react';
import React from 'react';
import { CustomValidity, Replacement } from '.';

export class NumericInputDS extends HTMLElement {
  required?: boolean;
  maxLength?: string;
  class?: string;
  value: unknown;
  label?: string;
  replacement?: string | Replacement[];
  type?: string;
  max?: string;
  min?: string;
  customValidityPattern?: string | CustomValidity[];
  suffix?: string;
  placeholder?: string;

  constructor() {
    super();
  }
}

export const NumericInput = createComponent(React, 'numeric-input', NumericInputDS, {
  onInputChange: 'input-changed',
  onFocus: 'element-focused',
  onLetterChanged: 'letter-changed',
  onBlur: 'element-blured',
});
